<!-- 系统管理-菜单管理 -->
<template>
  <div class="md-layout">
    <!-- 卡片-主菜单 {点开子菜单时, 非手机模式下, 和子菜单的卡片1:1占屏; 在手机模式下, 隐藏主菜单卡片 } -->
    <div class="md-layout-item " :class="{'md-size-50': table_hasSub,'md-size-100': !table_hasSub}" v-if="!table_hasSub || !$root.state.mobile">
      <md-card>
        <!-- 卡片-主体 -->
        <md-card-content>
          <add-button @click="table_addItem">{{$I18n("add_main_menu")}}</add-button>
          <!-- 表格 { 点击后可展示对应的子菜单 }
            ID
            名称 {中文下显示中文, 其他时候显示英文}
            菜单KEY
            操作 [修改主菜单, 删除主菜单]
           -->
          <md-table v-model="tableData" @md-selected="table_selectMainMenu">
            <md-table-row slot="md-table-row" slot-scope="{ item }"  md-selectable="single">
              <md-table-cell :md-label="$I18n('menu_id')" class="numbers">{{ item.menu_id }}</md-table-cell>
              <md-table-cell :md-label="$I18n('menu_name')">
                {{ $I18n("lang_i18n") === "zh" ? item.menu_cn_name : item.menu_name }}
              </md-table-cell>
              <md-table-cell :md-label="$I18n('menu_key')">{{ item.menu_key }}</md-table-cell>
              <md-table-cell :md-label="$I18n('sort')">{{ item.sort }}</md-table-cell>
              <md-table-cell :md-label="$I18n('operate')" class="button-box">
                <md-button @click="table_editItem(item)" @click.stop class="md-just-icon md-round md-info left-icon">
                  <md-icon>edit</md-icon>
                </md-button>
                <md-button @click="table_deleteItem(item)" @click.stop class="md-just-icon md-round md-danger md-info">
                  <md-icon>close</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
            <md-table-empty-state slot="md-table-empty-state">{{$I18n("none_data")}}</md-table-empty-state>
          </md-table>
        </md-card-content>
      </md-card>
    </div>
    <!-- 卡片-子菜单 {只在点开主菜单后显示} {非手机模式下, 和主菜单的卡片1:1占屏; 在手机模式下, 隐藏主菜单只显示该卡片} -->
    <template v-if="!$root.state.mobile || table_hasSub">
      <div class="md-layout-item" :class="{'md-size-0':!$root.state.mobile, 'md-size-50':table_selectedMain.menu_id && !$root.state.mobile, 'md-size-100':$root.state.mobile}">
        <md-card >
          <!-- 卡片-主体 -->
          <md-card-content>
            <div>
              <add-button @click="table_addSubItem">{{$I18n("add_sub_menu")}}</add-button>
              <md-button v-if="$root.state.mobile" @click="() => {table_selectMainMenu()}" :style="{'margin-right': '10px'}" class="md-primary md-sm md-info right-button md-just-icon md-round">
                <md-icon>reply</md-icon>
              </md-button>
            </div>
            <!-- 表格 { 点击后可展示对应的子菜单 }
              ID
              名称 {中文下显示中文, 其他时候显示英文}
              菜单KEY
              操作 [修改子菜单, 删除子菜单]
             -->
            <md-table v-model="selected">
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell :md-label="$I18n('menu_id')" class="numbers">{{ item.menu_id }}</md-table-cell>
                <md-table-cell :md-label="$I18n('menu_name')">
                  {{ $I18n("lang_i18n") === "zh" ? item.menu_cn_name : item.menu_name }}
                </md-table-cell>
                <md-table-cell :md-label="$I18n('menu_key')">{{ item.menu_key }}</md-table-cell>
                <md-table-cell :md-label="$I18n('sort')">{{ item.sort }}</md-table-cell>
                <md-table-cell :md-label="$I18n('operate')"  class="button-box">
                  <md-button @click.stop="table_editSubItem(item)" class="md-just-icon md-round md-info left-icon">
                    <md-icon>edit</md-icon>
                  </md-button>
                  <md-button @click.stop="table_deleteSubItem(item)" class="md-just-icon md-round md-danger md-info">
                    <md-icon>close</md-icon>
                  </md-button>
                </md-table-cell>
              </md-table-row>
              <md-table-empty-state slot="md-table-empty-state"> {{$I18n("none_data")}} </md-table-empty-state>
            </md-table>
          </md-card-content>
        </md-card>
      </div>
    </template>
    <!-- 弹窗 -->
    <simple-modal 
      ref    = "modal"
      :title = "modal_title"
      :right = "!openModalType.includes('delete')"
      @submit= "modal_submit"
      @close = "closeModal"
    >
      <template slot="body">
        <!-- 确认信息 {只在删除主/子菜单的时候才展示该部分} -->
        <div v-if="openModalType.includes('delete')">
          {{$I18n("check_delete", $I18n("lang_i18n") === "zh" ?modalData.Form.menu_cn_name :modalData.Form.menu_name)}}
        </div>
        <!-- 表单-修改/添加菜单表单 -->
        <div v-else>
          <common-form-item 
            v-for="item in form_modalData" 
            v-model="modalData.Form[item.keys]" 
            :error="modalData.Error[item.keys]" 
            :key="item.keys" v-bind="item"
          />
        </div>
      </template>
    </simple-modal>
  </div>
</template>
<script>
import { FormClass } from "@/common/tools.js";
export default {
  data() {
    return {
      table_hasSub : false,   // 表格-是否要显示子菜单表格
      table_selectedMain: {}, // 表格-正在选择的主菜单的 子菜单列表

      icon  : "assignment",            // 卡片-ICON
      title : this.$I18n("main_menu"), // 卡片-标题
      tableData : [],                  // 表格-展示数据

      openModal: false,      // 弹窗-是否打开
      openModalType : "add", // 弹窗-弹窗展示内容类型 "delete" | "edit" | "sub-add" | "sub-edit" | "sub-delete"
      modal_title : "",      // 弹窗-标题
      modalData :new FormClass({ // 弹窗-表单数据
        menu_id   : {
          init    : "",
          check   : "int",
        },
        menu_key  : {
          init    : "",
          check   : "required",
        },
        menu_name : {
          init    : "",
          check   : "required",
        },
        menu_cn_name : {
          init    : "",
          check   : "required",
        },
        sort : {
          init    : "0",
          check   : (val) => {
            return isNaN(val) || parseInt(val) != parseFloat(val) || parseInt(val) < 0
          },
        },
      }),
    };
  },
  mounted : function() {
    this.api_getPageData();
  },
  watch: {
    '$root.state':{
      handler(){
        return 
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    selected(){       // 表格-子菜单表格对应数据
      if(this.table_selectedMain.sub_menus) {
        return this.table_selectedMain.sub_menus;
      } else {
        return [];
      }
    },
    form_modalData(){
      return [
        {
          label   : this.$I18n("menu_id"),
          keys    : "menu_id",
          type    : "input",
          required: true,
          check   : true,
          disabled: this.openModalType.includes('edit'),
          placeholder: this.$I18n('pls_input_menu_id'),
        },{
          label   : this.$I18n("menu_key"),
          keys    : "menu_key",
          type    : "input",
          required: true,
          check   : true,
          disabled: this.openModalType.includes('edit'),
          placeholder: this.$I18n('pls_input_menu_key'),
        },{
          label   : this.$I18n("menu_name"),
          keys    : "menu_name",
          type    : "input",
          required: true,
          check   : true,
          placeholder: this.$I18n('pls_input_menu_name'),
        },{
          label   : this.$I18n("menu_cn_name"),
          keys    : "menu_cn_name",
          type    : "input",
          required: true,
          check   : true,
          placeholder: this.$I18n('pls_input'),
        },{
          label   : this.$I18n("sort"),
          keys    : "sort",
          type    : "input",
          check   : true,
          placeholder: this.$I18n('pls_input'),
        }
      ]
    },
  },
  methods: {
    closeModal(){// 关闭表单时重新查询表格数据,以及重置弹窗内的校验结果
        if (this.openModalType === "add" || this.openModalType === "edit" || this.openModalType === "delete"){
          this.api_getPageData();
        }else {
          this.api_getPageDataOnlySub(this.table_selectedMain.menu_id);
        }
        this.modalData.Reset();
    },
    table_selectMainMenu(item){       // 表格-选择/取消选择 主菜单 (即决定是否展示子菜单表格)
      if (item){
        this.table_selectedMain = item;
        this.table_hasSub = true;
      } else {
        this.table_selectedMain = {};
        setTimeout(() => {
          if(this.selected.length === 0){
            this.table_hasSub = false;
          }
        },500)
      } 
    },
    api_getPageData(){                // API-获取主菜单信息
      //获取菜单
      this.$api.getMenu({ // api: /user/menu/query
        type : this.UserInfo.role_id != 1 ? 1 : 0,
      })
        .then(this.$Then(res => {
          this.tableData = res.data;
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.tableData = [];
        }))
    },
    api_getPageDataOnlySub(main_id) { // API-获取页面数据 (仅更新特定的子菜单数据)
      //获取菜单
      this.$api.getMenu({ // api: /user/menu/query
        type : this.UserInfo.role_id != 1 ? 1 : 0,
      })
        .then(this.$Then(res => {
          let newArray = res.data.filter(item => {
            return item.menu_id === main_id;
          })[0].sub_menus;

          if (newArray){
            this.tableData.filter(item => {
              return item.menu_id === main_id;
            })[0].sub_menus = newArray;
            this.table_selectedMain.sub_menus = newArray;
          } else {
            this.tableData.filter(item => {
              return item.menu_id === main_id;
            })[0].sub_menus = [];
            this.table_selectedMain.sub_menus = [];
          }
        }))
        .catch(this.$Catch(this.$I18n("get_error")))
    },
    modal_closeModal () {             // 弹窗-隐藏表格
      this.$refs.modal.close()
    },
    table_addItem  (){ // 表格-打开 添加主菜单 弹窗
      this.modal_title = this.$I18n("add_main_menu");
      this.openModalType = "add";
      this.modalData.Reset();
      this.$refs.modal.open()
    },
    table_editItem (item){ // 表格-打开 修改主菜单 弹窗
      this.modal_title = this.$I18n("edit_menu");
      this.openModalType = "edit";
      this.modalData.Update(item);
      this.$refs.modal.open()
    },
    table_deleteItem (item){ // 表格-打开 删除主菜单 弹窗
      this.modal_title = this.$I18n("del_menu");
      this.openModalType = "delete";
      this.modalData.Update(item);
      this.$refs.modal.open()
    },
    modal_submit () { // 弹窗-提交表单数据
      if (this.openModalType === "add") { // 提交 添加菜单
        this.modal_submitAdd();
      } else if (this.openModalType === "edit"){ // 提交 修改菜单
        this.modal_submitEdit();
      } else if(this.openModalType === "delete"){ // 提交 删除菜单
        this.modal_submitDel();
      } else if (this.openModalType === "sub-add") { // 提交 添加子菜单
        this.modal_submitAdd();
      } else if (this.openModalType === "sub-edit"){ // 提交 修改子菜单
        this.modal_submitEdit();
      } else if (this.openModalType === "sub-delete"){ // 提交 删除子菜单
        this.modal_submitDel();
      }
    },
    modal_submitAdd () { // 弹窗-提交 添加菜单
      if (this.modalData.Check()) {
        this.$errorMsg(this.$I18n("pls_check_verify"));
        return;
      }
      this.$api.addMenu({ // api: /user/menu/add
        ...this.modalData.Form,
        menu_id : parseInt(this.modalData.Form.menu_id),
        menu_parent_id : this.openModalType === "add" ?0 :this.table_selectedMain.menu_id,
      })
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("add_success"));
          this.modal_closeModal();
        }))
        .catch(this.$Catch(this.$I18n("add_fail")))
    },
    modal_submitEdit () { // 弹窗-提交 修改菜单
      if (this.modalData.Check()) {
        this.$errorMsg(this.$I18n("pls_check_verify"));
        return;
      }
      this.$api.editMenu(this.modalData.Form)
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("edit_success"));
          this.modal_closeModal();
        }))
        .catch(this.$Catch(this.$I18n("edit_fail")))
    },
    modal_submitDel (){ // 弹窗-提交 删除菜单
      this.$api.deleteMenu(this.modalData.Form)
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("delete_success"));
          this.modal_closeModal();
        }))
        .catch(this.$Catch(this.$I18n("delete_fail")))
    },
    table_addSubItem() { // 表格-打开 添加子菜单 弹窗
      this.modal_title = this.$I18n("add_sub_menu");
      this.openModalType = "sub-add";

      this.modalData.Reset();
      this.$refs.modal.open()
    },
    table_editSubItem (item){ // 表格-打开 修改子菜单 弹窗
      this.modal_title = this.$I18n("edit_menu");
      this.openModalType = "sub-edit";
      this.modalData.Update(item);
      this.$refs.modal.open()
    },
    table_deleteSubItem (item){ // 表格-打开 删除子菜单 弹窗
      this.modal_title = this.$I18n("delete_menu");
      this.openModalType = "sub-delete";
      this.modalData.Update(item);
      this.$refs.modal.open()
    },
  },
}
</script>
<style lang="scss" scoped>
  .md-layout {
    overflow: hidden;
  }
  // 弹窗的表单
  .md-form-label{
    font-size: 16px;
  }
  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  // 表格的ID列
  .numbers {
    width: 100px;
  }
  // 表格的按钮列
  .button-box {
    width: 120px;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }
</style>